import { errorPagesConfigs } from './errorPages';
import { authRouteConfig } from './auth';
import { initialUrl } from '../shared/constants/AppConst';
import Error403 from './errorPages/Error403';
import React from 'react';
import Error404 from './errorPages/Error404';
import { catalogConfig } from './catalog';
import { promotionsConfig } from './promotions';
import { configurationConfig } from './configuration';
import { ordersConfig } from './orders';
import { financeConfig } from './finance';
import { policyConfig } from './policy';
import { manageShopConfig } from './manage-shops/route';

const Customers = React.lazy(() => import('./customers'));
const PoliciesShop = React.lazy(() => import('./policies-shop'));

const authorizedStructure = {
  fallbackPath: '/sign-in',
  unAuthorizedComponent: <Error403 />,
  routes: [
    ...catalogConfig,
    ...promotionsConfig,
    ...configurationConfig,
    ...ordersConfig,
    ...financeConfig,
    ...policyConfig,
    ...manageShopConfig,
    {
      path: '/customers',
      element: <Customers />,
    },
    {
      path: '/policies-shop',
      element: <PoliciesShop />,
    },
  ],
};

const unAuthorizedStructure = {
  fallbackPath: initialUrl,
  routes: authRouteConfig,
};

const anonymousStructure = {
  routes: errorPagesConfigs.concat([
    {
      path: '*',
      element: <Error404 />,
    },
  ]),
};

export { authorizedStructure, unAuthorizedStructure, anonymousStructure };
